<template>
  <div class="common-no-data fb fb-col fb-cross-center fb-main-center">
    <div class="item-flex-1"></div>
    <div>
      <img
        v-if="type === 'expired'"
        class="icon"
        src="@/assets/images/no-expired.png"
      />
      <img v-else class="icon" src="@/assets/images/no-welcome.png" />
      <slot></slot>
      <p v-if="content" class="font-28 no-text">{{ content }}</p>
    </div>
    <div class="item-flex-2"></div>
  </div>
</template>
<script>
export default {
  name: 'commonEmptyWechat',
  props: {
    type: {
      type: String,
      default: 'expired'
    },
    content: {
      type: String,
      default: '链接已失效'
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.common-no-data {
  width: 100%;
  position: absolute;
  top: 0;
  right: 100%;
  bottom: 0;
  left: 0;
  .icon {
    display: block;
    width: 180px;
    margin: 0 auto;
  }
  .no-text {
    text-align: center;
    color: rgba(23, 26, 29, 0.4);
  }
}
</style>
